/** Class. */
export class Class {
  constructor(data) {
    this.arriveTime = data.arriveTime;
    this.categoryId = data.categoryId;
    this.classDate = data.classDate;
    this.classLocation = data.classLocation;
    this.endTime = data.endTime;
    this.examArriveTime = data.examArriveTime;
    this.examEndTime = data.examEndTime;
    this.examStartTime = data.examStartTime;
    this.id = data.id;
    this.isAlmostFull = data.isAlmostFull;
    this.isInstantResults = data.isInstantResults ?? false;
    this.language = data.language;
    this.name = data.name;
    this.seatsLeft = data.seatsLeft;
    this.seatsTaken = data.seatsTaken;
    this.startTime = data.startTime;
    this.statusId = data.statusId;
    this.isPublic = data.isPublic;
  }
}
